var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookFilledWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 226 413"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M221.5 145H150v-40c0-20.64 1.68-33.64 31.26-33.64l37.36-1V6.76C200.44 4.88 182.16 5 163.86 5 109.6 5 70 38.14 70 99v46H9v80h60v183h82V224.94h61.32z"
  })));
}

export default __webpack_public_path__ + "static/media/facebook_filled_white.c2eff9f42c145d73e4581700fc18fbfc.svg";
export { SvgFacebookFilledWhite as ReactComponent };